import $dayjs from '@/services/date'

/**
 * Determines whether the month component of a date to be presented should
 * preceed the day component for a specified locale.
 *
 * @param locale The locale to check
 * @returns {Boolean}
 */
const isMonthBeforeDay = (locale) => {
  return (
    $dayjs()
      .locale(locale.toLowerCase())
      .localeData()
      .longDateFormat('L') === 'MM/DD/YYYY'
  )
}

export { isMonthBeforeDay }
